function isCustomEvent(e) {
    if (e instanceof CustomEvent && 'detail' in e) {
        return true;
    }
    return false;
}
function isKeyOfObject(key, obj) {
    return typeof key !== 'undefined' && obj && typeof obj === 'object' && key in obj;
}

export { isKeyOfObject as a, isCustomEvent as i };

//# sourceMappingURL=index12.js.map